import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17.657 11a6 6 0 1 0 -11.315 0","key":"svg-0"}],["path",{"d":"M6.342 11l5.658 11l5.657 -11l-11.315 0","key":"svg-1"}]]

const IconIceCream2 = createReactComponent('outline', 'ice-cream-2', 'IceCream2', __iconNode);

export default IconIceCream2;